module.exports = __webpack_public_path__ + "media/images/flags/64/Somalia-214c1be1c7133453e2dca41357c293c4.png";